export default __webpack_public_path__ + "assets/ac491e5d727fb1bca7f9373dd4d572d6.png";